module.exports = __webpack_public_path__ + "img/62c5f44d10851ef4d3ac34d90a48fa0d.png";